import gql from 'graphql-tag';

export const STORE_SITE_FRAGMENT = gql`
    fragment StoreSite on StoreSite {
        id
        createdAt
        updatedAt
        name
        description
        identifier
        seller {
            id
            name
        }
        sellerChannel {
            id
            code
            customFields {
                notificationEmail
                subscriptionEnabled
            }
        }

        distributionTenantId
        status

        headerMessageConfig {
            displayOrder
            switchType
            autoSwitchInterval
            messageList {
                format
                i18n
            }
        }
        logoSection {
            normalLogoId
            footerLogoId
            smallLogoId
            nameLogoId
            browserIconId
            webclipIconId
        }

        siteStyles {
            siteTitle
            displayHeaderMenu
            displayFooterMenu
            displayStoreName
            displayHeaderMessage
            copyrightNotice {
                format
                i18n
            }
            disclaimer {
                format
                i18n
            }
            pdpAssetsArrowType
            mobileBuyBannerType
        }
        colorConfig {
            mainColor
            mainTextColor
            secondaryColor
            secondaryTextColor
            headerBackgroundColor
            headerFontColor
            footerBackgroundColor
            footerFontColor
        }
        snsInfoSection {
            instagram
            facebook
            xTwitter
            youtube
            tiktok
        }

        navigationMenu {
            targetType
            label
            pageSlug
            pageSection
            builtInPage
            customSlug
            websiteUrl
            targetProductId
            targetProductSlug
            targetCollectionId
            targetCollectionSlug
        }
        mobileSecondaryNavigationMenu {
            targetType
            label
            pageSlug
            pageSection
            builtInPage
            customSlug
            websiteUrl
            targetProductId
            targetProductSlug
            targetCollectionId
            targetCollectionSlug
        }
        policyContentList {
            type
            title
            path
            content
        }
        footerNavigationColumns {
            name
            items {
                targetType
                label
                pageSlug
                pageSection
                builtInPage
                customSlug
                websiteUrl
                targetProductId
                targetProductSlug
                targetCollectionId
                targetCollectionSlug
            }
        }

        storeUrl

        supportEmail
        contactUsAddress {
            company
            streetLine1
            streetLine2
            city
            province
            postalCode
            countryCode
            phoneNumber
        }

        pages {
            id
            name
            slug
            type
            pageComponents {
                type
                sectionId
            }
        }
    }
`;

export const EXPORT_SITE = gql`
    mutation ExportSite($id: ID!) {
        exportSite(id: $id)
    }
`;
export const IMPORT_SITE = gql`
    mutation ImportSite(
        $identifier: String!
        $input: String!
        $importPages: Boolean
        $pageConflictStrategy: PageConflictStrategy
        $importSiteName: Boolean
        $importIcons: Boolean
        $importColorTheme: Boolean
        $importSocialLinks: Boolean
        $importPolicies: Boolean
    ) {
        importSite(
            identifier: $identifier
            input: $input
            importPages: $importPages
            pageConflictStrategy: $pageConflictStrategy
            importSiteName: $importSiteName
            importIcons: $importIcons
            importColorTheme: $importColorTheme
            importSocialLinks: $importSocialLinks
            importPolicies: $importPolicies
        )
    }
`;

export const CREATE_DISTRIBUTION_TENANT = gql`
    mutation CreateDistributionTenant {
        createDistributionTenant
    }
`;
